/**
 * Shopify Storefront Tracker v2.1
 *
 * Records every user action as an independent event.
 * Sends to MCN Agent server in real-time.
 *
 * UTM source: URL params only (no localStorage).
 * sessionStorage carries UTM within same tab (product page → cart → checkout).
 * Direct visits (no UTM) tracked as (direct).
 */
(function () {
  'use strict';

  if (window._aikTrackerLoaded) return;
  window._aikTrackerLoaded = true;

  var API = 'https://mcn-agent-test.azurewebsites.net/api/v1/shopify-events/track';
  var STORE = 'jp';  // 'sg' or 'jp' — set per store deployment
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  var SS_UTM_KEY = '_aik_utm';     // sessionStorage: UTM data
  var SS_SID_KEY = '_aik_sid';     // sessionStorage: session ID
  var SS_STS_KEY = '_aik_sts';     // sessionStorage: session timestamp
  var SESSION_TIMEOUT = 30 * 60 * 1000; // 30 min

  // ── UTM: read from URL, store in sessionStorage ──
  function captureUtm() {
    var params = new URLSearchParams(window.location.search);
    var found = {};
    var hasUtm = false;
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) { found[k] = v; hasUtm = true; }
    });

    if (hasUtm && found.utm_content) {
      // URL has UTM → store in sessionStorage (lives until tab closes)
      try { sessionStorage.setItem(SS_UTM_KEY, JSON.stringify(found)); } catch (e) {}
      // Also set cookie for Web Pixel checkout page access
      try { document.cookie = '_aik_utm=' + encodeURIComponent(JSON.stringify(found)) + ';path=/;max-age=2592000;SameSite=Lax'; } catch (e) {}
      // New UTM = new session
      newSession();
      // Write cart attributes for Shopify order webhook attribution
      writeCartAttributes(found);
    }
    // If URL has no UTM, don't touch sessionStorage — it may have UTM from the product page
  }

  function getUtm() {
    // 1. Check sessionStorage (carried from product page within same tab)
    try {
      var raw = sessionStorage.getItem(SS_UTM_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    // 2. No UTM anywhere → return null (will be tracked as "direct")
    return null;
  }

  // ── Session Management ──
  function getSessionId() {
    try {
      var sid = sessionStorage.getItem(SS_SID_KEY);
      var sts = parseInt(sessionStorage.getItem(SS_STS_KEY) || '0');
      if (!sid || (Date.now() - sts) > SESSION_TIMEOUT) {
        return newSession();
      }
      sessionStorage.setItem(SS_STS_KEY, String(Date.now()));
      return sid;
    } catch (e) {
      return 'sid_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
    }
  }

  function newSession() {
    var sid = 'sid_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
    try {
      sessionStorage.setItem(SS_SID_KEY, sid);
      sessionStorage.setItem(SS_STS_KEY, String(Date.now()));
    } catch (e) {}
    return sid;
  }

  // ── Device Detection ──
  function getDevice() {
    var w = window.innerWidth;
    if (w <= 768) return 'mobile';
    if (w <= 1024) return 'tablet';
    return 'desktop';
  }

  function getBrowser() {
    var ua = navigator.userAgent;
    if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edg') === -1) return 'Chrome';
    if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) return 'Safari';
    if (ua.indexOf('Firefox') > -1) return 'Firefox';
    if (ua.indexOf('Edg') > -1) return 'Edge';
    return 'Other';
  }

  // ── Send Event ──
  function send(eventName, extra) {
    var u = getUtm();
    var data = {
      event: eventName,
      store: STORE,
      session_id: getSessionId(),
      utm_content: u ? u.utm_content : '(direct)',
      utm_source: u ? (u.utm_source || '') : '',
      utm_medium: u ? (u.utm_medium || '') : '',
      utm_campaign: u ? (u.utm_campaign || '') : '',
      page: window.location.pathname,
      page_title: document.title,
      referrer: document.referrer,
      device: getDevice(),
      browser: getBrowser(),
    };
    if (extra) {
      for (var k in extra) data[k] = extra[k];
    }
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify(data),
    }).catch(function () {});
  }

  function beacon(eventName, extra) {
    var u = getUtm();
    var data = {
      event: eventName,
      store: STORE,
      session_id: getSessionId(),
      utm_content: u ? u.utm_content : '(direct)',
      utm_source: u ? (u.utm_source || '') : '',
      utm_medium: u ? (u.utm_medium || '') : '',
      utm_campaign: u ? (u.utm_campaign || '') : '',
      page: window.location.pathname,
      page_title: document.title,
      device: getDevice(),
      browser: getBrowser(),
    };
    if (extra) {
      for (var k in extra) data[k] = extra[k];
    }
    navigator.sendBeacon(API, JSON.stringify(data));
  }

  // ── Write Cart Attributes (for checkout/order webhook UTM) ──
  function writeCartAttributes(u) {
    var attrs = {};
    UTM_KEYS.forEach(function (k) { if (u[k]) attrs[k] = u[k]; });
    if (!Object.keys(attrs).length) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function () {});
  }

  // ── Track: Page View ──
  function trackPageView() {
    var isProduct = window.location.pathname.indexOf('/products/') !== -1;
    send('page_view');
    if (isProduct) {
      send('view_item');
    }
  }

  // ── Track: Page Leave + Duration ──
  function trackPageLeave() {
    var startTime = Date.now();
    var sent = false;

    function onLeave() {
      if (sent) return;
      sent = true;
      var duration = Math.round((Date.now() - startTime) / 1000);
      if (duration < 1) return;

      var nextPage = 'exit';
      if (document.activeElement && document.activeElement.href) {
        try {
          var url = new URL(document.activeElement.href);
          if (url.hostname === window.location.hostname) {
            nextPage = url.pathname;
          }
        } catch (e) {}
      }

      beacon('page_leave', { duration: duration, next_page: nextPage });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') onLeave();
    });
    window.addEventListener('pagehide', onLeave);
    window.addEventListener('beforeunload', onLeave);
  }

  // ── Track: Add to Cart (hook fetch) ──
  function hookAddToCart() {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] || '';
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        var detail = '';
        try {
          var body = arguments[1] && arguments[1].body;
          if (body) {
            var parsed = JSON.parse(body);
            var items = parsed.items || [];
            detail = items.map(function (i) { return 'id=' + i.id + ' qty=' + (i.quantity || 1); }).join(', ');
          }
        } catch (e) {}
        send('add_to_cart', { detail: detail });
      }
      return origFetch.apply(this, arguments);
    };

    var origXHR = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        send('add_to_cart');
      }
      return origXHR.apply(this, arguments);
    };
  }

  // ── Track: Checkout Button Click ──
  function hookCheckout() {
    if (window.location.pathname.indexOf('/cart') === -1) return;

    document.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== document) {
        if (t.tagName === 'BUTTON' || t.tagName === 'A' || t.tagName === 'INPUT') {
          var txt = (t.textContent || t.value || '').toLowerCase().trim();
          if (txt.indexOf('check out') !== -1 || txt.indexOf('checkout') !== -1 ||
            t.getAttribute('name') === 'checkout' ||
            (t.closest && t.closest('form[action*="checkout"]'))) {
            send('checkout', { detail: 'checkout_button' });
            break;
          }
        }
        t = t.parentNode;
      }
    }, true);
  }

  // ── Init ──
  captureUtm();
  trackPageView();
  trackPageLeave();
  hookAddToCart();
  hookCheckout();
})();
